import React from 'react';
import styles from './CodeDiffViewer.module.scss';
import cx from 'classnames';

interface CodeDiffLineProps {
  line: {
    type: 'unchanged' | 'removed' | 'added';
    content: string;
    oldLineNumber: number | null;
    newLineNumber: number | null;
  };
}

export const CodeDiffLine: React.FC<CodeDiffLineProps> = ({ line }) => {
  let indicator = ' ';
  let lineNumber = '';
  let lineClass = styles.unchanged;

  if (line.type === 'added') {
    indicator = '+';
    lineNumber = line.newLineNumber !== null ? String(line.newLineNumber) : '';
    lineClass = styles.added;
  } else if (line.type === 'removed') {
    indicator = '-';
    lineNumber = line.oldLineNumber !== null ? String(line.oldLineNumber) : '';
    lineClass = styles.removed;
  } else {
    indicator = ' ';
    lineNumber =
      line.oldLineNumber !== null
        ? String(line.oldLineNumber)
        : line.newLineNumber !== null
          ? String(line.newLineNumber)
          : '';
    lineClass = styles.unchanged;
  }

  return (
    <div className={cx(styles.diffLine, lineClass)}>
      <span className={styles.lineIndicator}>{indicator}</span>
      <span className={styles.lineNumber}>{lineNumber}</span>
      <span className={styles.lineContent}>{line.content}</span>
    </div>
  );
};
